<button (click)="scrollToTop()" class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <i class="fas fa-hand-point-up" aria-hidden="true"></i>
</button>
